import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $(this.element).popover({
      container: 'body'
    })
  }

  disconnect() {
    // Check if popover exists before destroying
    if ($(this.element).data('bs.popover')) {
      $(this.element).popover('destroy')
    }
  }
}